import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { MotionBox } from '@olo-web/components/atoms/motion/MotionBox.ui';

/**
 * This element is friendly with autofocus on iOS devices bringing the keyboard focusing on an
 * input/textarea as long as a) the focus is handled with an onClick and b) the element is
 * visible at that point.
 * More info https://stackoverflow.com/a/16601288/6922467
 */

interface IMotionCollapseProps {
  children: JSX.Element;
  isOpen: boolean;
  id?: string;
}

export function MotionCollapse({ children, isOpen, id }: IMotionCollapseProps) {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <MotionBox
          id={id}
          key={id || 'collapse'}
          initial="collapsed"
          animate="open"
          exit="collapsed"
          variants={{
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 0, height: 0 },
          }}
          transition={{ duration: 0.3 }}
          overflow="hidden"
        >
          {children}
        </MotionBox>
      )}
    </AnimatePresence>
  );
}
